// import { connect } from 'react-redux';
// import { modalActions } from '../../../reducers/modal.reducer';

import ModalHeader from '../modal/ModalHeader.react';

// import Button from '../Button.react';

var Help = function Help() {
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Questions and Support"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body confirmation-modal__body",
    style: {
      width: 480
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "help"
  }, "For support, questions and bug reports please contact ", /*#__PURE__*/React.createElement("a", {
    href: "mailto:dan@codistudios.com"
  }, "dan@codistudios.com"), ".")));
};
export default Help;